import { postText, requireUrl } from "../http.js";

export function createCustomAdapter(config) {
    return {
        async connect() {
            requireUrl(config.endpoint, "Custom endpoint URL");
            return true;
        },
        async test() {
            return this.send("");
        },
        async send(text = "") {
            return postText(
                requireUrl(config.endpoint, "Custom endpoint URL"),
                text,
                { authHeader: config.auth },
                true,
            );
        },
        async clear() {
            return this.send("");
        },
        async disconnect() {
            return true;
        },
    };
}
